module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper border-bottom white-bg page-heading"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.loading) ? _c('heading-loading') : _c('h1', [(_vm.editingUser) ? _c('div', [_c('i', {
    staticClass: "far fa-user-circle m-r-sm"
  }), _vm._v(" " + _vm._s(_vm.accountUser.profile.full_name) + "\n          ")]) : _c('div', [_c('i', {
    staticClass: "far fa-user-circle m-r-sm"
  }), _vm._v(" Create Account User\n          ")])])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-7a93c303"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/account-users/AccountUserHeading.vue
// module id = 1050
// module chunks = 0